export default {
    isProduction: () => process.env.NODE_ENV === 'production',
    isPbe: () => !!process.env.IS_PBE_BUILD,
    isDevelopment: () => process.env.NODE_ENV !== 'production',
    isDebugBuild: () => !!process.env.IS_DEBUG_BUILD,
}